import React, { forwardRef, useEffect, useState } from 'react';
// material
import CloseIcon from '@material-ui/icons/Close';
import {
  Slide,
  Dialog,
  AppBar,
  Toolbar,
  Typography,
} from '@material-ui/core';
//
import ViewTicketCrm from 'src/pages/dashboard/ViewTicketCrm';

const Transition = forwardRef((props, ref) => <Slide direction="down" ref={ref} {...props} />);

function FullScreenDialogTicket({
  open,
  setOpen,
  ticketId: initialTicketId,
  ticketName: initialTicketName,
  setRefreshTickets,
  refreshTickets,
  onDataChange
}) {

  const [ticketId, setTicketId] = useState(
    localStorage.getItem('ticketId') || initialTicketId || ''
  );
  const [ticketName, setTicketName] = useState(
    localStorage.getItem('ticketName') || initialTicketName || ''
  );

  useEffect(() => {
    if (open) {
      localStorage.setItem('ticketId', ticketId);
      localStorage.setItem('ticketName', ticketName);
      localStorage.setItem('ticketOpenDialog', 'true');
    } else {
      // Only remove the dialog flag when explicitly closed, not on refresh
      if (!localStorage.getItem('ticketOpenDialog')) {
        localStorage.removeItem('ticketOpenDialog');
      }
    }
  }, [open, ticketId, ticketName]);

  useEffect(() => {
    if (open) {
      setTicketId(localStorage.getItem('ticketId') || initialTicketId || '');
      setTicketName(localStorage.getItem('ticketName') || initialTicketName || '');
    }
  }, [open]);

  // Check on component mount if dialog should be open
  useEffect(() => {
    const shouldOpen = localStorage.getItem('ticketOpenDialog') === 'true';
    const savedTicketId = localStorage.getItem('ticketId');
    const savedTicketName = localStorage.getItem('ticketName');
    
    if (shouldOpen && savedTicketId && !open) {
      setTicketId(savedTicketId);
      setTicketName(savedTicketName || '');
      // Don't automatically set open to true here, let parent component handle it
    }
  }, []);

  const handleClose = () => {
    setTicketId("");
    setTicketName("");
    setOpen(false);
    // Clear localStorage when explicitly closing
    localStorage.removeItem('ticketId');
    localStorage.removeItem('ticketName');
    localStorage.removeItem('ticketOpenDialog');
  };


  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar position="relative" mb={3}>
          <Toolbar>
            <Typography variant="h6" sx={{ flex: 1, ml: 2 }}>
              {ticketName ? `${ticketName}` : 'Ticket Details'}
            </Typography>
            <CloseIcon onClick={handleClose} sx={{fontSize:'2.7rem',cursor:'pointer'}}/>
          </Toolbar>
        </AppBar>
        <MemoizedViewTicketCrm
          popupOn={true}
          ticketId={ticketId}
          closeView={handleClose}
          onDataChange={onDataChange} // Pass data change handler from parent
          setRefreshTickets={setRefreshTickets}
          refreshTickets={refreshTickets}
        />
      </Dialog>
    </>
  );
}

const MemoizedViewTicketCrm = React.memo(ViewTicketCrm);

export default React.memo(FullScreenDialogTicket);
